import React from 'react';
import './RoomInfoSection.css';

const RoomInfoSection = () => {
  return (
    <section className="room-info-section">
      <div className="room-info-container">
        <div className="info-cards-grid">
          <div className="info-card">
            <h3>Room Policies & Information</h3>
            <ul className="info-list">
              <li>
                <strong>Check-in Time:</strong>
                12:00 PM onwards
              </li>
              <li>
                <strong>Check-out Time:</strong>
                11:00 AM
              </li>
              <li>
                <strong>Early Check-in/Late Check-out:</strong>
                Subject to availability, additional charges may apply
              </li>
            </ul>
          </div>
          <div className="info-card">
            <h3>Identification & Stay</h3>
            <ul className="info-list">
              <li>
                <strong>Couple Friendly</strong>
                Yes, we welcome unmarried couples.
              </li>
              <li>
                <strong>Valid ID Proof</strong>
                Aadhar Card, Driving License, Passport, or Voter ID required for all guests.
              </li>
              <li>
                <strong>Payment Methods</strong>
                Cash, UPI, and Card payments accepted.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoomInfoSection;
